// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@flip/App/SharedStyle/MyAccount/List/MyAccountFilterSectionStyles";
import { color, mergeWithCss } from "@flip/XDL/Utilities";
import translate from "@insite/client-framework/Translate";
import { headerStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListHeader";
import { css } from "styled-components";

headerStyles.container = {
    ...myAccountFilterSectionStyles.filterContainer,
};
headerStyles.orderApprovalCountGridItem = {
    ...myAccountFilterSectionStyles.countGridItem,
};
headerStyles.toggleFilterGridItem = {
    ...mergeWithCss(myAccountFilterSectionStyles.toggleFilterGridItem, {
        css: css`
            &:after {
                content: "";
            }

            button[data-test-selector="orderApproval_toggleFilter"] {
                min-width: 120px;
                height: 55px;
                text-align: center;
                padding: 10px 15px;
                border: 1px solid ${color("common.ui3")};
                border-top: 5px solid ${color("primary.main")}; /* XNGAGE Changes */
                color: ${color("text.main")}; /* XNGAGE Changes */
                justify-content: center;
                font-size: 18px;
                background: ${color("common.white")};

                &:after {
                    content: "${translate("Filter")}";
                    font-weight: bold;
                }

                &:hover:after {
                    color: ${color("primary")};
                    outline: none;
                }

                &:focus {
                    outline: none;
                }
            }
        `,
    }),
};
headerStyles.toggleFilterButtonIcon = { ...myAccountFilterSectionStyles.toggleFilterIcon };
headerStyles.toggleFilterButton = {
    ...myAccountFilterSectionStyles.toggleFilterButton,
};
